import React, { useState } from "react";
import { auth } from "../../firebase";
import { 
  updatePassword, 
  createUserWithEmailAndPassword, 
  EmailAuthProvider, 
  reauthenticateWithCredential 
} from "firebase/auth";

const Settings = () => {
  const currentUser = auth.currentUser;
  const [newAdminEmail, setNewAdminEmail] = useState("");
  const [newAdminPassword, setNewAdminPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  
  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setMessage({ text: "", type: "" });
    
    if (newPassword !== confirmPassword) {
      setMessage({ text: "New passwords don't match", type: "danger" });
      return;
    }
    
    try {
      // First, reauthenticate with current credentials
      const credential = EmailAuthProvider.credential(
        currentUser.email,
        currentPassword
      );
      
      await reauthenticateWithCredential(currentUser, credential);
      
      // If reauthentication succeeds, update password
      await updatePassword(currentUser, newPassword);
      
      setMessage({ text: "Password updated successfully", type: "success" });
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      // Handle specific authentication errors
      if (error.code === 'auth/wrong-password') {
        setMessage({ text: "Current password is incorrect", type: "danger" });
      } else {
        setMessage({ text: `Error: ${error.message}`, type: "danger" });
      }
    }
  };
  
  const handleCreateAdmin = async (e) => {
    e.preventDefault();
    setMessage({ text: "", type: "" });
    
    try {
      await createUserWithEmailAndPassword(auth, newAdminEmail, newAdminPassword);
      setMessage({ text: "New admin account created successfully", type: "success" });
      setNewAdminEmail("");
      setNewAdminPassword("");
    } catch (error) {
      setMessage({ text: `Error: ${error.message}`, type: "danger" });
    }
  };

  return (
    <div className="settings-section fadeIn">
      <div className="admin-card">
        <div className="card-header">
          <h3>Settings</h3>
        </div>
        <div className="card-body">
          {message.text && (
            <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
              {message.text}
              <button type="button" className="btn-close" onClick={() => setMessage({ text: "", type: "" })} aria-label="Close"></button>
            </div>
          )}
          
          <ul className="nav nav-tabs mb-4" id="settingsTabs" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="true">Profile</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="security-tab" data-bs-toggle="tab" data-bs-target="#security" type="button" role="tab" aria-controls="security" aria-selected="false">Security</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="admin-accounts-tab" data-bs-toggle="tab" data-bs-target="#admin-accounts" type="button" role="tab" aria-controls="admin-accounts" aria-selected="false">Admin Accounts</button>
            </li>
          </ul>
          
          <div className="tab-content" id="settingsTabsContent">
            <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <h4 className="mb-3">Profile Information</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" value={currentUser?.email || ""} disabled />
                </div>
                <div className="mb-3">
                  <label className="form-label">Role</label>
                  <input type="text" className="form-control" defaultValue="Administrator" disabled />
                </div>
              </form>
            </div>
            
            <div className="tab-pane fade" id="security" role="tabpanel" aria-labelledby="security-tab">
              <h4 className="mb-3">Change Password</h4>
              <form onSubmit={handlePasswordChange}>
                <div className="mb-3">
                  <label className="form-label">Current Password</label>
                  <input 
                    type="password" 
                    className="form-control" 
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">New Password</label>
                  <input 
                    type="password" 
                    className="form-control" 
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Confirm New Password</label>
                  <input 
                    type="password" 
                    className="form-control" 
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">Update Password</button>
              </form>
            </div>
            
            <div className="tab-pane fade" id="admin-accounts" role="tabpanel" aria-labelledby="admin-accounts-tab">
              <h4 className="mb-3">Create New Admin Account</h4>
              <form onSubmit={handleCreateAdmin}>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input 
                    type="email" 
                    className="form-control" 
                    value={newAdminEmail}
                    onChange={(e) => setNewAdminEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input 
                    type="password" 
                    className="form-control" 
                    value={newAdminPassword}
                    onChange={(e) => setNewAdminPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">Create Admin Account</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
